import React, { useState, useEffect } from "react";
import axios from "axios";
import "./StatusDayEndPerform.css"; // our custom styles

const StatusDayEndPerform = () => {
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_SERVER_API}dayend-performStatus`
      );
      setData(res.data);
    } catch (error) {
      console.error("Error fetching Dayend Perform data:", error);
    }
  };

  const totalOutlets = data.length;
  const totalTrue = data.filter((item) => item.DayendPerform).length;
  const totalFalse = data.filter((item) => !item.DayendPerform).length;

  const filteredData =
    filter === "all"
      ? data
      : data.filter((item) =>
          filter === "true" ? item.DayendPerform : !item.DayendPerform
        );

  return (
    <div className="dayend-container">
      <div className="dayend-card">
        <h4 className="dayend-title">Day End Perform Status</h4>

        {/* Summary */}
        <div className="summary-grid">
          <div className="summary-box total">
            <h6>Total Outlets</h6>
            <h5>{totalOutlets}</h5>
          </div>
          <div className="summary-box performed">
            <h6>Performed</h6>
            <h5>{totalTrue}</h5>
          </div>
          <div className="summary-box not-performed">
            <h6>Not Performed</h6>
            <h5>{totalFalse}</h5>
          </div>
        </div>

        {/* Filter Buttons */}
        <div className="button-group">
          <button
            className={`filter-btn ${filter === "all" ? "active" : ""}`}
            onClick={() => setFilter("all")}
          >
            All
          </button>
          <button
            className={`filter-btn success ${filter === "true" ? "active" : ""}`}
            onClick={() => setFilter("true")}
          >
            Day End Perform
          </button>
          <button
            className={`filter-btn danger ${filter === "false" ? "active" : ""}`}
            onClick={() => setFilter("false")}
          >
            Day End Not Perform
          </button>
        </div>

        {/* Outlet List */}
        <ul className="outlet-list">
          {filteredData.map((item, idx) => (
            <li key={idx} className="outlet-item">
              <span>{item.Outlet_Name}</span>
              <span
                className={`badge ${
                  item.DayendPerform ? "success" : "danger"
                }`}
              >
                {item.DayendPerform ? "Day End" : "Not Performed"}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default StatusDayEndPerform;
